import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {courier} = api

/**
 * 查找
 */
export async function findCourier(params) {
    return request({url: courier, method: 'get', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/courier.js